// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","containerMessage":"containerMessage--3whQm","myMessage":"myMessage--3Pspw","guestMessage":"guestMessage--1u2x-","unreadMessage":"unreadMessage--qmenx"};